import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ページ遷移時にメニューを閉じる
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'TOP' },
    { path: '/booking', label: '予約' },
    { path: '/book', label: '書籍案内' },
    { path: '/profile', label: 'プロフィール' },
  ];

  const textColor = isScrolled || menuOpen ? 'text-[#2C2C2C]' : 'text-white';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/9bc45319-956d-4152-8254-f9a19b862440.png"
              alt="Dr.Catch"
              className="h-10 md:h-12 w-auto"
            />
            <span className={`text-lg md:text-xl font-semibold tracking-widest whitespace-nowrap ${textColor}`}>
              Dr.Catch
            </span>
          </Link>

          {/* PC: Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#C9A0A0]'
                    : isScrolled
                    ? 'text-[#2C2C2C] hover:text-[#C9A0A0]'
                    : 'text-white hover:text-[#F5E8E4]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* SP: Hamburger Button */}
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="メニュー"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* SP: Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#F5E8E4] shadow-lg">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-8 py-4 text-base font-medium border-b border-[#F5E8E4] cursor-pointer transition-colors ${
                location.pathname === link.path
                  ? 'text-[#C9A0A0]'
                  : 'text-[#2C2C2C] hover:text-[#C9A0A0]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
